import { render, staticRenderFns } from "./TsDividerTitle.vue?vue&type=template&id=a080cca6&"
import script from "./TsDividerTitle.vue?vue&type=script&lang=js&"
export * from "./TsDividerTitle.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports